/* Carrossel animado das "Peças em destaque": avança sozinho a cada 3,5 s, pausa no toque/mouse. */
(function () {
  function start(slider) {
    if (!slider || slider.dataset.kgAuto) return;
    slider.dataset.kgAuto = '1';
    let paused = false;
    ['mouseenter', 'touchstart', 'focusin'].forEach(e => slider.addEventListener(e, () => (paused = true), { passive: true }));
    ['mouseleave', 'touchend', 'focusout'].forEach(e => slider.addEventListener(e, () => setTimeout(() => (paused = false), 2500), { passive: true }));
    setInterval(() => {
      if (paused || document.hidden) return;
      const item = slider.querySelector('.slider__slide');
      if (!item) return;
      const step = item.getBoundingClientRect().width + 8;
      const end = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4;
      slider.scrollTo({ left: end ? 0 : slider.scrollLeft + step, behavior: 'smooth' });
    }, 3500);
  }
  function init() { document.querySelectorAll('[id^="Slider-template--"][id*="__pecas"]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Links de WhatsApp sempre em nova aba (cliente não sai da loja). */
(function () {
  function fix() { document.querySelectorAll('a[href*="wa.me/"]').forEach(a => { a.target = '_blank'; a.rel = 'noopener'; }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  document.addEventListener('click', e => { const a = e.target.closest && e.target.closest('a[href*="wa.me/"]'); if (a) { a.target = '_blank'; a.rel = 'noopener'; } }, true);
})();

/* Banner inteiro clicável → coleção (pedido da Karol: "clicar no banner e ir para a coleção nova"). */
(function () {
  function init() {
    document.querySelectorAll('slideshow-component:not(.announcement-bar) .slideshow__slide').forEach(slide => {
      const link = slide.querySelector('a[href]');
      if (!link || slide.dataset.kgClick) return;
      slide.dataset.kgClick = '1';
      slide.style.cursor = 'pointer';
      slide.addEventListener('click', e => { if (e.target.closest('a, button')) return; window.location.href = link.href; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
